<div>
  <div
    class="mainContentSection"
  >
    <div
      class="backToDuelPopUp"
      (click)="backToPlayerModal()"
    >
      <mat-icon
        class="iconBackgroundStyle"
      >
        chevron_left
      </mat-icon>
      <div
        class="linkBackDecoration"
      >
        Назад
      </div>
    </div>
    <div
      class="tournamentNameStyle"
    >
      Видео игрока
    </div>
    <div
      class="photoAndTable"
    >
      <div>
        <div class="photoContainerSize">
          <img src="{{playerData?.image || '/static/img/avatar/1.jpg'}}"
               class="imageStyle"
               alt="Player photo"
          >
        </div>
        <div
          class="photoCaption"
        >
          <div
            class="playerNameStyle"
            (click)="backToPlayerModal()"
          >
            {{playerData?.full_name}}
          </div>
          <div
            class="yearAndTitle"
          >
            {{playerData?.birthdate?.split('-')[0] + (playerData?.title ? (', ' + playerData?.title) : '')}}
          </div>
          <div
            class="country"
            *ngIf="playerData?.city"
          >
            {{playerData?.city.region.country.name}}
          </div>
          <div
            class="city"
            *ngIf="playerData?.city.name"
          >
            {{playerData?.city.name}}
          </div>
        </div>
      </div>

      <div class="tableDiv">
        <table class="tableSize">
          <thead>
            <tr class="tableHeaderFonts tableHeader">
              <th class="tableHeaderCell">Номер встречи</th>
              <th class="tableHeaderCell"></th>
              <th class="tableHeaderCell">Счёт встречи</th>
              <th class="tableHeaderCell"></th>
              <th class="tableHeaderCell"></th>
            </tr>
          </thead>
          <tbody *ngFor="let tournament of getAllTournaments()">
            <tr class="tableRowTournament">
              <td colspan="5" class="tableRowCell">
                <a href="/tournament/{{tournament}}/info">{{ getTournamentName(tournament) }}</a>
              </td>
            </tr>
            <tr class="tableRow" *ngFor="let duel of getDuelsForTournament(tournament)">
              <td class="tableRowCell">{{ duelsInfo[duel].number }}</td>
              <td class="tableRowCell">{{ getPlayerWinner(duelsInfo[duel]) }}</td>
              <td class="tableRowCell">
                <div class="scoreCellStyle">
                  <div [ngClass]="winnerStyle(duelsInfo[duel])">
                    {{ getPlayerWinnerScore(duelsInfo[duel]) }}
                  </div>
                  <div class="scoreCell defeatedCell">
                    {{ getPlayerLooserScore(duelsInfo[duel]) }}
                  </div>
                </div>
              </td>
              <td class="tableRowCell">{{ getPlayerLooser(duelsInfo[duel]) }}</td>
              <td class="tableRowCell">
                <a href="{{ duelsInfo[duel].youtube_link }}" target="_blank" class="youtubeLink">
                  <i class="fa-solid fa-video"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

